import 'react-multi-carousel/lib/styles.css'
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import { useRouter } from 'next/router'
import parse from 'html-react-parser'

// External libraries
import { SearchActivityHomeWidget, SearchHotelHomeWidget } from '@/lib/searchHomeWidget'
import { toggleFavorite } from '../../../../../common/lib/favorite'

import AuthContext from 'store/auth-context'
import cf from '@/lib/utils/common'

// Dynamic imports
const Carousel = dynamic(() => import('react-multi-carousel'), {
  loading: () => <p>loading...</p>,
  ssr: false,
})
// Helper to detect video files
const isVideo = (url = '') => /\.(mp4|webm|ogg)$/i.test(url)

const HotelSearchWidget = dynamic(
  () => import('../../../../../common/components/widgets/hotelSearchWidget/index.js')
)
const SearchWidgetActivity = dynamic(
  () => import('../../../../../common/components/widgets/activityWidget/index')
)
const PromotionBanner = dynamic(() => import('@/components/promotionBanner'))
const Card = dynamic(() => import('@../../../common/componentsV2/Activity/Card'))
const RecentSearch = dynamic(() => import('@../../../common/componentsV2/Activity/RecentSearch'))

// Components
import CustomLink from '@/components/Link'
import Link from '../../../../../common/Link.js'
import ActivityMobileSearchWidget from '../../../../../common/components/widgets/activityWidgetMobile/index.js'
import ModalPopupComponent from '../../../../../common/components/ModalPopupComponent/theme2/ModalPopupComponent.js'
import MoreMenu from '../../../../../common/components/Moremenu/index.js'
import { VmsCarousel } from '@/components/vms-components/Carousel'
import LoginComponent from '@/commonComponents/login/Theme12/index'

// CSS imports
import styles from './index.module.css'
import Countrystyles from '../../../../../common/components/CountryDropdown/theme12/index.module.css'
import b2bWidgetStyle from '../../../../../common/components/b2bwidgets/theme4/index.module.css'
import DesktopHotelStylesTheme2 from '../../../../../common/components/widgets/hotelSearchWidget/theme12/index.module.css'
import ActivityTheme2cssfile from '../../../../../common/components/widgets/activityWidget/theme12/index.module.css'
import PopupMobCss from '../../../../../common/components/ModalPopupComponent/theme12/index.module.css'

import registercssTheme12 from '../../../../../common/components/login/Theme12/Registration/register.module.css'
import dropdownStylesTheme12 from '../../../../../common/components/pageBreakup/Dropdown/theme12/index.module.css'
import isdDropdownStyles12 from '../../../../../common/components/pageBreakup/IsdDropDown/theme12/index1.module.css'
import titledropdownStylesTheme12 from '../../../../../common/components/pageBreakup/Dropdown/theme12/title.module.css'
import basiccss12 from '../../../../../common/components/login/Theme12/index.module.css'
import modalCssTheme12 from '../../../../../common/componentsV2/modalPopUp/themeCss/theme12.module.css'
// import PopupMobCss from '../../../../../common/components/ModalPopupComponent/theme12mobile/index.module.css'

import ActivitySearchMobileThemeOneCSS from '../../../../../common/components/widgets/activityWidgetMobile/theme2/index.module.css'
import swPopupCss from '../../../../../common/components/widgets/commonCss/swPopupCssTheme2.module.css'
import paxCompStyle from '../../../../../common/components/PaxComp/Theme12/index.module.css'
import MoremenuCss from '../../../../../common/components/header/theme12/index.module.css'
import cardCss from '../../../../../common/componentsV2/Activity/Card/themeCss/theme12.module.css'
import RecentSearchCss from '../../../../../common/componentsV2/Activity/RecentSearch/themeCss/theme12.module.css'
import { myActivityBooking } from '@/lib/myBooking';


// Carousel functions
import {
  myGreetingMySwiper,
  myGreetingMySwiper2,
  myGreetingElevatenew,
  myGreetingChild_featureSwiper,
  myGreetingTestimonial_data,
  myGreetingMyclientSwiper,
  myGreetingOffermain,
  myGreetingNewlyadded,
  myGreetingMostbooked,
  myGreetingExploremain,
  myGreetingBudgetSwiper,
  lazyyoutube,
  myGreetingsliderthreeonehalf,
  myGreetingsliderfivetwohalf,
  myGreetingsliderfourtwohalf,
  myGreetingslidersixtwohalf,
  myGreetingslidersixtwohalfbv,
  myGreetingsliderfouronehalfbv,
  myGreetingsliderfourtwohalfbv,
  myGreetingsliderfivetwohalfbv,
  myGreetingsliderthreeonehalfbv

} from '../../../../public/js/carousalFun.js'

const availableSearchTypes = [
  'hotel_search',
  'activity_search',
  'experience_search',
  'car_search',
  'others_search',
]
// const upcomingBookingData = [
//   {
//     id: 1,
//     search_text: 'Dubai Desert Safari',
//     destination: 'Dubai',
//     activity_date: '2025-09-20',
//     activity_time: '16:00',
//     duration: '6 hours',
//     adults: 2,
//     children: 1,
//     total_participants: 3,
//     price: '$150',
//     currency: 'USD',
//     activity_type: 'Adventure',
//     rating: 4.8,
//   },
//   {
//     id: 2,
//     search_text: 'Burj Khalifa Sky Deck',
//     destination: 'Dubai',
//     activity_date: '2025-09-22',
//     activity_time: '19:00',
//     duration: '2 hours',
//     adults: 4,
//     children: 0,
//     total_participants: 4,
//     price: '$200',
//     currency: 'USD',
//     activity_type: 'Sightseeing',
//     rating: 4.9,
//   },
//   {
//     id: 3,
//     search_text: 'Abu Dhabi City Tour',
//     destination: 'Abu Dhabi',
//     activity_date: '2025-09-25',
//     activity_time: '08:00',
//     duration: '8 hours',
//     adults: 2,
//     children: 2,
//     total_participants: 4,
//     price: '$120',
//     currency: 'USD',
//     activity_type: 'Cultural',
//     rating: 4.7,
//   },
//   {
//     id: 4,
//     search_text: 'Abu Dhabi City Tour',
//     destination: 'Abu Dhabi',
//     activity_date: '2025-09-25',
//     activity_time: '08:00',
//     duration: '8 hours',
//     adults: 2,
//     children: 2,
//     total_participants: 4,
//     price: '$120',
//     currency: 'USD',
//     activity_type: 'Cultural',
//     rating: 4.7,
//   },
//   {
//     id: 5,
//     search_text: 'Abu Dhabi City Tour',
//     destination: 'Abu Dhabi',
//     activity_date: '2025-09-25',
//     activity_time: '08:00',
//     duration: '8 hours',
//     adults: 2,
//     children: 2,
//     total_participants: 4,
//     price: '$120',
//     currency: 'USD',
//     activity_type: 'Cultural',
//     rating: 4.7,
//   },
//   {
//     id: 6,
//     search_text: 'Abu Dhabi City Tour',
//     destination: 'Abu Dhabi',
//     activity_date: '2025-09-25',
//     activity_time: '08:00',
//     duration: '8 hours',
//     adults: 2,
//     children: 2,
//     total_participants: 4,
//     price: '$120',
//     currency: 'USD',
//     activity_type: 'Cultural',
//     rating: 4.7,
//   },
// ]


export default function Theme12Flow(props) {
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const wrapperRef = useRef(null)
  const setMoreWrapperRef = useRef(null)
  const [expandHotelNameBoolean, setExpandHotelName] = useState(false)
  const [expandActivityName, setExpandActivityName] = useState(false)
  const [getHotelAutoSuggestList, setHotelAutoSuggestList] = useState([])
  const [getActivityAutoSuggestList, setActivityAutoSuggestList] = useState([])
  const [initHotelData, setInitHotelData] = useState([])
  const [homeBodyDesktop, setHomeBodyDesktop] = useState([])
  const [homeBodyMobile, setHomeBodyMobile] = useState([])
  const [hotelDefultDays, setHotelDefultDays] = useState(0)
  const [userProfile, setUserProfile] = useState('')
  const [indexOfWidgetToshow, setIndexOfWidget] = useState(1)
  const [widClicked, setWidClicked] = useState(false)
  const [SerachWidget, setSerachWidget] = useState('activity')
  const [SerachWidMob, setSerachWidMob] = useState('activity')
  const ctx = useContext(AuthContext)
  const hotelWidRef = useRef(null)
  const [menuData, setMenuData] = useState('')
  const [isPopup, setPopup] = useState(false)
  const [isMobWid, setIsMobWid] = useState(false)
  const [isActive, setIsActive] = useState('activity')
  const [getrecentSearchList, setrecentSearchList] = useState([])
  const [openMorePopup, setopenMorePopup] = useState(false)
  const [upcomingBookingData, setUpcomingBookingData] = useState([]);
  const [continueJourney, setContinueJourney] = useState(JSON.parse(localStorage.getItem('continueJourney')) || []);

  const [loginPopupOpen, setLoginPopupOpen] = useState(false);
  const [usedToggleFavorite, setUsedToggleFavorite] = useState(false);
  const [toggledfavoriteState, setToggledFavoriteState] = useState(false);
  const [activeMsg, setActiveMsg] = useState(null);
  const [isDestinationDropdownOpen, setIsDestinationDropdownOpen] = useState(false);


  const isVideo = (url = '') => {
    return /\.(mp4|webm|ogg)$/i.test(url);
  };

  // below code is for adding a class to section div for background colour for active tab
  const extractedPathname = window.location.pathname;


  // 

  const [state, setState] = useState({
    showBreakfast: false,
    showFreeCancellation: false,
    recentSearchClicked: true,
    selectedRatings: [],
    hotelName: '',
    getDestinationId: '',
    getSearchType: 6,
    property_count: '',
    dest_type: { code: '', text: '' },
  })

  const box = useRef(null)

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      // slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 1023, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  }
  const recentResponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1.5,
      slidesToSlide: 1, // optional, default to 1.
    },
  }

  const fetchBookingData = () => {
    let data = {
      email: props?.home?.data?.data?.user?.email || '',
      site_id: props?.home?.data?.site?.id,
      type: "upcoming"
    }
    myActivityBooking(data).then((res) => {
      if (res?.data?.status) {
        setUpcomingBookingData({ experiences: res?.data?.data?.bookings || [] });
      }
    })
  }
  useEffect(() => {
    if (activeMsg !== null) {
      const timer = setTimeout(() => {
        setActiveMsg(null);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [activeMsg]);

  useEffect(() => {
    if (!usedToggleFavorite) {
      setUsedToggleFavorite(true);
    }
  }, [toggledfavoriteState])
  useEffect(() => {
    fetchBookingData()
    console.log(props?.home, 'Hello New')
  }, [])

  useEffect(() => {
    let userToken = cf.getCookieTocken('userToken')
    cf.getUserProfile(userToken, props.site_id).then((res) => {
      if (res.status === true) {
        setUserProfile(ctx?.user)
      } else {
        setUserProfile(res)
      }
    })





    if (props?.home?.data?.data?.body?.desktop) {
      setHomeBodyDesktop(props.home.data.data.body.desktop)

      let headerMenuData = props.isMobile
        ? props?.home?.data?.data?.header?.mobile?.menu
        : props?.home?.data?.data?.header?.menu

      let defaultService = headerMenuData.filter((ele) => ele.status.toLowerCase() == 'active')

      if (defaultService.length > 0) {
        setSerachWidget(defaultService[0].code)
        setSerachWidMob(defaultService[0].code)
        setIsActive(defaultService[0].code)
      }

      /**FIND FIRST AVILLABLE WIDGET**/
      let indexOfFirstWidghts = props.home.data.data.body.desktop?.findIndex((x) =>
        availableSearchTypes.includes(x.type)
      )
      setIndexOfWidget(indexOfFirstWidghts)

      let hotelIndex = props.home.data.data.body.desktop.findIndex(
        (items) => items.type === 'hotel_search'
      )
      if (hotelIndex > -1) {
        setHotelDefultDays(props.home.data.data.body.desktop[hotelIndex].default_days)
      }
    }
    if (props?.home?.data?.data?.body?.mobile) setHomeBodyMobile(props.home.data.data.body.mobile)
    const style = document.createElement('style')
    if (
      !cf.isValueEmpty(props) &&
      !cf.isValueEmpty(props.home) &&
      !cf.isValueEmpty(props.home.data)
    ) {
      style.innerHTML = props.home.data.data.css
      document.head.appendChild(style)
    }
    setActiveItemIndex(activeItemIndex)
    if (!cf.isValueEmpty(props) && !cf.isValueEmpty(props.home) && props.home.status === true) {
      if (
        !cf.isValueEmpty(props.home.data.data) &&
        !cf.isValueEmpty(props.home.data.data.body) &&
        !cf.isValueEmpty(props.home.data.data.body.desktop) &&
        props.home.data.data.body.desktop.length > 0
      ) {
        let hotelIndex = props.home.data.data.body.desktop.findIndex(
          (items) => items.type === 'hotel_search'
        )

        // if (hotelIndex !== -1) {
        //   if (
        //     !cf.isValueEmpty(props.home.data.data.body.desktop[hotelIndex].locations) &&
        //     props.home.data.data.body.desktop[hotelIndex].locations.length > 0
        //   ) {
        //     setInitHotelData([...props.home.data.data.body.desktop[hotelIndex].locations])
        //     console.log([...props.home.data.data.body.desktop[hotelIndex].locations], 'Hello Brother')
        //     setHotelAutoSuggestList([...props.home.data.data.body.desktop[hotelIndex].locations])
        //   }
        // }
        const popData = props?.home?.data?.data?.body?.desktop[hotelIndex]?.locations || props?.home?.data?.data?.body?.mobile[hotelIndex]?.locations
        if (hotelIndex !== -1) {
          if (
            !cf.isValueEmpty(popData) &&
            popData.length > 0
          ) {
            setInitHotelData([...popData])
            // console.log([...props.home.data.data.body.desktop[hotelIndex].locations], 'Hello Brother')
            setHotelAutoSuggestList([...popData])
          }
        }

      }
    }
    // showMore()
    // <script>
    //    {showMore()}
    // </script>

    document.addEventListener('click', handleClickOutside, false)
    return () => {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [])

  const getAutoSuggestDataFunc = (value, section, type, event, tripType = '') => {
    switch (section) {
      case 'hotel':
        if (value.length > 0) {
          SearchHotelHomeWidget({ autoSuggest: value }).then((res) => {
            if (!cf.isValueEmpty(res) && res.status === true && !cf.isValueEmpty(res.data)) {
              if (res.data.status === 'success' && !cf.isValueEmpty(res.data.result)) {
                setHotelAutoSuggestList([...res.data.result.records])
                setrecentSearchList([...res.data.result.recent_search])
                setExpandHotelName(true)
              }
            }
          })
        } else {
          setHotelAutoSuggestList([...initHotelData])
          setExpandHotelName(true)
        }
        break
      case 'activity':
        SearchActivityHomeWidget({ autoSuggest: value }).then((res) => {
          if (!cf.isValueEmpty(res) && !cf.isValueEmpty(res.data) && res.data.status === true) {
            if (
              !cf.isValueEmpty(res.data.searchBycity) &&
              res.data.searchBycity !== 'Not Found' &&
              res.data.searchBycity.status === 'success'
            ) {
              if (
                !cf.isValueEmpty(res.data.searchBycity.result) &&
                res.data.searchBycity.result.length > 0
              ) {
                getActivityAutoSuggestList.cityList = [...res.data.searchBycity.result]
                //     setActivityAutoSuggestList({ ...getActivityAutoSuggestList })
                setActivityAutoSuggestList([...res.data.searchBycity.result])
                if (expandActivityName === false) {
                  setExpandActivityName(true)
                }
              }
              if (
                !cf.isValueEmpty(res.data.searchBycountry) &&
                res.data.searchBycountry !== 'Not Found' &&
                res.data.searchBycountry.status === 'success'
              ) {
                if (
                  !cf.isValueEmpty(res.data.searchBycountry.result) &&
                  res.data.searchBycountry.result.length > 0
                ) {
                  getActivityAutoSuggestList.countryList = [...res.data.searchBycountry.result]
                  //      setActivityAutoSuggestList({ ...getActivityAutoSuggestList })
                  setActivityAutoSuggestList([
                    ...getActivityAutoSuggestList.cityList,
                    ...getActivityAutoSuggestList.countryList,
                  ])

                  if (expandActivityName === false) {
                    setExpandActivityName(true)
                  }
                }
              }
            }
          }
        })
        break
      default:
        break
    }
  }

  const onClickRecentSearch = (value) => {
    setState({ recentSearchClicked: value })
  }

  const updateRecentSearch = (element) => {

    // Parse the checkin date
    let checkinDate = moment(element.checkin, 'DD-MM-YYYY')

    // Validate checkin date - set to current date if in the past
    let currentDate = moment()
    if (checkinDate.isBefore(currentDate, 'day')) {
      checkinDate = currentDate // Set to current date if past
    }

    // Update state with formatted dates and other data
    setState({
      hotelName: element?.search_text,
      getDestinationId: element?.destination_id,
      getSearchType: element?.search_type ? element?.search_type : 6,
      property_count: element?.property_count,
      dest_type: {
        code: element?.dest_type?.code,
        text: element?.dest_type?.text,
      },
      recentSearchClicked: true,
      checkin: checkinDate.format('DD-MMM-YYYY'), // formatted date
      checkout: element?.checkout,
      selectedRoomDetails: element?.selectedRoomDetails,
      roomList: element?.roomList,
      showBreakfast: element?.is_breakfast,
      showFreeCancellation: element?.is_free_cancellation,
    })
  }

  const handleClickOutside = (event) => {
    // console.log('eventevent', event)
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      if (expandHotelNameBoolean === true) setExpandHotelName(false)
    }
    if (hotelWidRef.current && !hotelWidRef.current.contains(event.target)) {
      setWidClicked(false)
    }
    if (setMoreWrapperRef.current && !setMoreWrapperRef.current.contains(event.target)) {
      setopenMorePopup(false)
    }
  }

  const imageLoader = ({ src }) => {
    return `${'/shared/api/media/' + props.site_id + '/' + src}`
  }

  const getMediaUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return `${'/shared/api/media/' + props.site_id}/${url}`;
  };

  const onClickWidgets = () => {
    setWidClicked(true)
  }

  const router = useRouter()
  const query = router.query.index
  const stays_villas = router.query.type == 'homestay'

  useEffect(() => {
    try {
      if (props?.home?.data?.data?.body?.desktop) {
        setHomeBodyDesktop(props.home.data.data.body.desktop)
      }

      if (props?.home?.data?.data?.body?.mobile) {
        setHomeBodyMobile(props.home.data.data.body.mobile)
      }

      if (window.location.pathname == '/hotel' || window.location.pathname == '/hotels') {
        setSerachWidget('hotel')
        setSerachWidMob('hotel')
        setIsActive('hotel')
      }

      if (window.location.pathname == '/activity' || window.location.pathname == '/activities') {
        setSerachWidget('activity')
        setSerachWidMob('activity')
        setIsActive('activity')
      }

      setTimeout(() => {
        ; (myGreetingMySwiper(),
          myGreetingMySwiper2(),
          myGreetingElevatenew(),
          myGreetingChild_featureSwiper(),
          myGreetingTestimonial_data(),
          myGreetingMyclientSwiper(),
          myGreetingOffermain(),
          myGreetingNewlyadded(),
          myGreetingMostbooked(),
          myGreetingExploremain(),
          myGreetingBudgetSwiper(),
          lazyyoutube(),
          myGreetingsliderthreeonehalf(),
          myGreetingsliderfivetwohalf(),
          myGreetingsliderfourtwohalf(),
          myGreetingslidersixtwohalf(),
          myGreetingslidersixtwohalfbv(),
          myGreetingsliderfouronehalfbv(),
          myGreetingsliderfourtwohalfbv(),
          myGreetingsliderfivetwohalfbv(),
          myGreetingsliderthreeonehalfbv()

        )
      }, 100)
    } catch (error) {
      console.log(error)
    }

  }, [query])

  // for mobile section ============>

  const onClickHeaderMenu = (data, i) => {
    setIsMobWid(true)

    if (data.code == 'hotel') {
      setSerachWidMob('hotel')
      setIsActive('hotel')
      window.location.href = data.url
    }
    if (data.code == 'activity') {
      setSerachWidMob('activity')
      setIsActive('activity')
      window.location.href = data.url
    }

    if (data.code == 'others') {
      window.location.href = data.url
      return
    }
    setMenuData(data.code)
    setPopup(true)
  }


  const copyCouponCode = (id) => {
    if (id) {
      var copyText = document.getElementById(id).innerHTML
      if (copyText) {
        navigator.clipboard.writeText(copyText)
        var copycouponcodeId = 'copycouponcode_' + id
        document.getElementById(copycouponcodeId).innerHTML = 'Copied'
        setTimeout(function () {
          document.getElementById(copycouponcodeId).innerHTML = 'Copy Code'
        }, 3000)
      }
    }
  }

  const setMorePopupHandler = () => {
    setopenMorePopup(!openMorePopup)
  }

  const handleDestinationDropdownChange = (isOpen) => {
    setIsDestinationDropdownOpen(isOpen);
  };

  const handleFavorite = (event, activity_id, wishlistValue) => {
    // handle favorite api call here
    event.stopPropagation();

    let payload = {
      lob_type: "activities",
      activity_code: activity_id,
      currency: "INR",
      access_token: props?.pageInfo?.data?.access_token,
      site_id: props?.pageInfo?.site?.id,
    }
    if (props?.home?.data?.data?.user?.rg_status == "A") {
      toggleFavorite(payload)
        .then((data) => {
          // Use fallback for API response
          if (data?.status) {
            if (data?.data?.status) {
              console.log("toggleFavorite success", data);
              setToggledFavoriteState(!toggledfavoriteState);
              setActiveMsg({ id: data?.data?.data?.activity_details?.activity_code, isFavorite: data?.data?.isRemoved });

              setContinueJourney(continueJourney?.map((item) => item?.activity_code == activity_id ? { ...item, is_wishlist: !wishlistValue } : item));
              localStorage.setItem('continueJourney', JSON.stringify(data?.data?.data?.continue_journey || []));
              // setTimeout(() => {
              //   setActiveMsg(null);
              // }, 5000);
              // console.log("toggleFavorite response", data);

            } else {
              // setLoginPopupOpen(true);
            }
          } else {
            // setLoginPopupOpen(true);


          }
        })
        .catch((err) => {
          console.log('error >>>>>>>>>')
          console.log(err)
        })
    } else {
      setLoginPopupOpen(true);


    }

    // setActivityResultData(activityResultData.map((item) => item.id === id ? { ...item, favorite: !item.favorite } : item))
    // setFavorite(!favorite)
    console.log('Favorite clicked!')

  }


  const renderRecentAndBooking = () => {
    return (
      <Fragment>
        {
          // continueJourney?.length >= 2 && upcomingBookingData?.experiences?.length >= 1 &&
          <div className={styles.recent_and_upcoming_main}>
            {continueJourney?.length >= 2 ? (
              <div className={styles.upcoming_bookings}>
                <>
                  <div className={styles.bookingheading}>Continue your journey</div>
                  {/* <div className={styles.flex_row}> */}
                  <VmsCarousel responsive={recentResponsive} arrows={false}>
                    {continueJourney?.map((item) => (
                      <div onClick={() => router.push(`/activity/details?activity_code=${item?.activity_code}`)}>
                        <Card
                          theme={"theme12"}
                          key={item.id}
                          cardType="verticalProduct"
                          data={item}
                          isMobile={props.isMobile}
                          styles={cardCss}
                          onFavorite={handleFavorite}
                          showFavoriteIcon={true}
                          activeMsg={activeMsg}
                        />
                      </div>
                    ))}
                  </VmsCarousel>

                  {/* </div> */}
                </>
              </div>
            ) : (
              null
            )}
            {upcomingBookingData?.experiences?.length >= 1 ? (
              <div className={styles.recent_bookings}>
                <>
                  <div className={styles.bookingheading}>Upcoming experiences</div>
                  <VmsCarousel responsive={recentResponsive} arrows={false}>
                    {upcomingBookingData?.experiences?.slice(0, 4)?.map((ele, index) => (
                      < div onClick={() => router.push(`/activity/managebooking?confirmationId=${ele?.order_no}`)}>
                        <RecentSearch
                          key={index}
                          ele={ele}
                          theme={props?.home?.data?.site?.site_theme}
                          props={props}
                          title="Upcoming experiences"
                          product_type="activity"
                          isMobile={props.isMobile}
                          styles={RecentSearchCss}
                        />
                      </div>
                    ))}
                  </VmsCarousel>
                </>
              </div>
            ) : (
              null
            )}
          </div>
        }

      </Fragment>
    )
  }

  return (
    <>
      {loginPopupOpen && (
        <LoginComponent
          data={{
            ...props,
            isMobile: props?.isMobile,
            directOpenLinkPopup: {
              popupPage: 'LoginWithMobile',
              popupCompoenet: 'login',
            },
            onClickCross: () =>
              setLoginPopupOpen(false),
            logincss: {
              registercssTheme12,
              dropdownStylesTheme12,
              isdDropdownStyles12,
              titledropdownStylesTheme12,
              basiccss12,
            },
            modalCss: { modalCssTheme12 }
          }}
        />
      )}
      {props?.isMobile ? (
        // For Mobile section =============>
        <>
          <>
            <div className={styles.mobilebanner_relation}>
              <div className={styles.home_containermainbanner}>
                {homeBodyMobile.map((res, i) => {

                  return (
                    <div key={'homeBodyMobile' + i} className={styles.home_banner_wrapper}>
                      {!cf.isValueEmpty(res.type) &&
                        res.type == 'image_carousal' &&
                        (res.banners && res.banners.length > 0 ? (
                          <div style={{ margin: 0 }}>
                            <Carousel
                              swipeable={false}
                              draggable={false}
                              showDots={false}
                              responsive={responsive}
                              ssr={false} // render carousel on server-side
                              infinite={true}
                              autoPlay={true}
                              autoPlaySpeed={3000}
                              keyBoardControl={true}
                              customTransition="all .5"
                              transitionDuration={500}
                              containerClass={styles.carouse_container2}
                              dotListClass="custom-dot-list-style"
                              itemClass="carousel-item-padding-40-px"
                              pauseOnHover={false}
                              shouldResetAutoplay={false}
                              arrows={false}
                            >

                              {

                                !cf.isValueEmpty(res) &&
                                !cf.isValueEmpty(res.banners) &&
                                res.banners.length > 0 &&

                                res.banners.map((imagedata, index) => {
                                  return (
                                    <div
                                      style={{ margin: 0 }}
                                      key={'banner' + index}
                                      className={styles.img_banner_home2}
                                    >
                                      {isVideo(imagedata?.image) ? (
                                        imagedata.banner_url ? (
                                          <CustomLink href={imagedata.banner_url}>
                                            <video
                                              src={getMediaUrl(imagedata.image)}
                                              autoPlay
                                              muted
                                              loop
                                              webkit-playsinline
                                              preload="metadata"
                                              playsInline
                                              className={styles.banner_media}
                                            />
                                          </CustomLink>
                                        ) : (
                                        <video
                                          src={getMediaUrl(imagedata.image)}
                                          autoPlay
                                          muted
                                          loop
                                          webkit-playsinline
                                          preload="metadata"
                                          playsInline
                                          className={styles.banner_media}
                                        />
                                        )
                                      ) : imagedata.banner_url ? (
                                        <CustomLink href={imagedata.banner_url}>
                                          <Image
                                            loader={imageLoader}
                                            src={imagedata?.image}
                                            width={500}
                                            layout="fill"
                                            alt="image-carousel"
                                          />
                                        </CustomLink>
                                      ) : (
                                        <Image
                                          loader={imageLoader}
                                          src={imagedata?.image}
                                          width={500}
                                          layout="fill"
                                          alt="image-carousel"
                                        />
                                      )}
                                    </div>
                                  );
                                })}
                            </Carousel>
                          </div>
                        ) : (
                          <div className={styles.nobanner}></div>
                        ))

                      }
                    </div>
                  )
                })}
              </div>
              <div className={`${window.location.pathname == '/' || window.location.pathname == '/activities' ? styles.mobilewidget_homepage : styles.mobilewidget} ${isDestinationDropdownOpen ? styles.mobilewidget_elevated : ''}`}>
                {
                  <p className={styles.explore_text}>Explore. Enjoy. Save More.</p>
                }

                <div className={styles.all_section}>
                  {props?.home?.data?.data?.header?.mobile?.menu?.map((link, i) => {
                    return (
                      <>
                        {link.status == 'Active' && (
                          <div
                            key={'headerMenu' + i}
                            className={`
                            ${styles.section_div} 
                          
                            ${extractedPathname === "/" && link.code === "activity" ? styles.active_service : ""} 
                            ${extractedPathname === "/hotels" && link.code === "hotel" ? styles.active_service : ""}
                            ${extractedPathname.startsWith("/activit") && link.code === "activity" ? styles.active_service : ""}
                          `}
                          >
                            {link?.code !== 'others' ? (
                              <Link title={link.text} key={link.text} href={link.url} className="">
                                <div
                                  className={styles.main_tab}
                                  onClick={() => {
                                    setIsActive(link.code)
                                    setSerachWidMob(link.code)
                                  }}
                                >
                                  <div
                                    className={`${styles.service_icon} ${isActive == link.code ? styles.active_service : ''
                                      }`}
                                  >
                                    <img
                                      src={`${'/shared/api/media/' + props.site_id + '/' + link.icon
                                        }`}
                                      alt=""
                                    />
                                  </div>
                                  <label
                                    className={`${isActive == link.code ? styles.active_label : ''}`}
                                  >
                                    {' '}
                                    {link.text}
                                  </label>
                                </div>
                              </Link>
                            ) : (
                              <a
                                title={link.text}
                                key={link.text}
                                href={
                                  localStorage.getItem('appType') == 'mobileapp' &&
                                    props?.isMobile &&
                                    (link.text == 'Forex' ||
                                      link.text == 'Visa' ||
                                      link.text == 'Vouchers')
                                    ? '/mobileAppLink?page=' + link.text + '&value=' + link.url
                                    : link.url
                                }
                                target="_blank"
                              >
                                <div className={styles.main_tab}>
                                  <div
                                    className={`${styles.service_icon} ${isActive == link.code ? styles.active_service : ''
                                      }`}
                                  >
                                    <img
                                      src={`${'/shared/api/media/' + props.site_id + '/' + link.icon
                                        }`}
                                      alt=""
                                    />
                                  </div>
                                  <label
                                    className={`${isActive == link.code ? styles.active_label : ''}`}
                                  >
                                    {' '}
                                    {link.text}
                                  </label>
                                </div>
                              </a>
                            )}
                          </div>
                        )}
                      </>
                    )
                  })}
                </div>

                <>
                  {SerachWidMob == 'hotel' && (

                    <div>
                      {console.log(getHotelAutoSuggestList, 'Hello Brother1')}

                      <HotelSearchWidget
                        pageTheme={props?.home?.data?.site?.site_theme}
                        isSRP={false}
                        isOffline={false}
                        styles={DesktopHotelStylesTheme2}
                        b2bStyles={b2bWidgetStyle}
                        getAutoSuggestValue={(value) => getAutoSuggestDataFunc(value, 'hotel')}
                        expandHotelNameBoolean={expandHotelNameBoolean}
                        getDefaultDays={hotelDefultDays}
                        getAutoSuggestList={getHotelAutoSuggestList}
                        getRecentSearchList={getrecentSearchList}
                        expandHotelNameBooleanfunc={(value) => setExpandHotelName(value)}
                        homeData={!cf.isValueEmpty(initHotelData) ? initHotelData : []}
                        dateFormat={props?.home?.data?.site?.date_format}
                        userProfile={userProfile}
                        Countrystyles={Countrystyles}
                        PopupMobCss={PopupMobCss}
                        PopularDestination={false}
                        paxCompStyle={paxCompStyle}
                        updateRecentSearch={updateRecentSearch}
                        state={state}
                        stays_villas={stays_villas}
                        onClickRecentSearch={onClickRecentSearch}
                        isMobile={props?.isMobile}
                        recentSearchData={''}
                        // setState ={setState}
                        setStateNew={(data) => setState({ ...state, ...data })}
                        selectedRatings={state.selectedRatings}
                      />
                    </div>
                  )}
                  {SerachWidMob == 'activity' && (
                    <div>
                      <SearchWidgetActivity
                        {...props}
                        //  cssfile={cssfile}
                        cssfile={ActivityTheme2cssfile}
                        pageTheme={props?.home?.data?.site?.site_theme}
                        calendarStyles={ActivityTheme2cssfile}
                        dateFormat={props?.home?.data?.site?.date_format}
                        b2bStyles={b2bWidgetStyle}
                        isMobile={props?.isMobile}
                        popupcss={PopupMobCss}
                        isSrp={false}
                        homePage={"homePage"}
                        onDestinationDropdownChange={handleDestinationDropdownChange}

                      />
                    </div>
                  )}
                </>
              </div>
            </div>


            {SerachWidget == 'activity' && renderRecentAndBooking()}

            <div className="main_body">
              {homeBodyMobile.map((res, i) => {
                return res?.type === 'promotion_banner' ? (
                  <div className={styles.promomainbanner} key={'homeBodyDsktp' + i} >
                    <PromotionBanner
                      theme={props?.home?.data?.site?.site_theme}
                      isMobile={props?.isMobile}
                      responsive={responsive}
                      res={res}
                      imageLoader={imageLoader}
                      cssstyles={styles}
                      showIndicators={true && res?.banners?.length > 1}
                    />
                  </div>
                ) : (
                  <div key={'homeBodyMbl' + i}>
                    {!cf.isValueEmpty(res.type) && res.type == 'image_banner' && (
                      <div className="img_banner_home">
                        <Image loader={imageLoader} src={res?.banners} width={500} layout="fill" />
                      </div>
                    )}
                    <div>
                      {!cf.isValueEmpty(res.html)
                        ? parse(res.html, {
                          replace: ({ attribs }) => {
                            if (attribs && attribs.copycouponcode === 'copy') {
                              return (
                                <p
                                  class="copyZth"
                                  copycouponcode="copy"
                                  copycouponcodevalue={attribs.copycouponcodevalue}
                                  copycouponcodenumber={attribs.copycouponcodenumber}
                                  id={attribs.id}
                                  onClick={() => copyCouponCode(attribs.copycouponcodenumber)}
                                >
                                  Copy Code
                                </p>
                              )
                            }
                          },
                        })
                        : // <Interweave content={res.html} />
                        ''}
                    </div>

                  </div>
                )
              })}
            </div>
          </>
        </>
      ) : (
        // for desktop Section =============>
        <>
          {/* carousal slider  starts */}

          <div className={styles.home_container}>

            <div className={styles.home_containermainbanner}>
              <h2 className={styles.explore_activity_title}>Explore. Enjoy. Save More.</h2>
              {homeBodyDesktop.map((res, i) => {
                return (
                  <div key={'homeBodyDsktp' + i} className={styles.home_banner_wrapper}>
                    {!cf.isValueEmpty(res.type) &&
                      res.type == 'image_carousal' &&

                      (res.banners && res.banners.length > 0 ? (
                        <div style={{ margin: 0 }} className={styles.banner_wrapper}>
                          <Carousel
                            swipeable={false}
                            draggable={false}
                            showDots={false}
                            responsive={responsive}
                            ssr={false}
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={6000}
                            keyBoardControl={true}
                            customTransition="all .5"
                            transitionDuration={500}
                            containerClass={styles.carouse_container2}
                            pauseOnHover={false}
                            shouldResetAutoplay={false}
                            arrows={false}
                          >
                            {!cf.isValueEmpty(res) &&
                              !cf.isValueEmpty(res.banners) &&
                              res.banners.length > 0 &&
                              res.banners.map((imagedata, index) => (
                                <div
                                  key={'banner' + index}
                                  className={styles.img_banner_home2}
                                >

                                  {isVideo(imagedata.image) ? (
                                    imagedata.banner_url ? (
                                          <CustomLink href={imagedata.banner_url}>
                                            <video
                                              src={getMediaUrl(imagedata.image)}
                                              autoPlay
                                              muted
                                              loop
                                              webkit-playsinline
                                              preload="metadata"
                                              playsInline
                                              className={styles.banner_media}
                                            />
                                          </CustomLink>
                                        ) : (
                                    <video
                                      src={getMediaUrl(imagedata.image)}

                                      autoPlay
                                      muted
                                      loop
                                      playsInline
                                      preload="auto"
                                      className={styles.banner_media}
                                    />)
                                  ) : imagedata.banner_url ? (
                                    <CustomLink href={imagedata.banner_url}>
                                      <Image
                                        loader={imageLoader}
                                        src={imagedata.image}
                                        width={500}
                                        layout="fill"
                                        alt="image-carousel"
                                      />
                                    </CustomLink>
                                  ) : (
                                    <Image
                                      loader={imageLoader}
                                      src={imagedata.image}
                                      width={500}
                                      layout="fill"
                                      alt="image-carousel"
                                    />

                                  )}
                                </div>
                              ))}
                          </Carousel>



                        </div>
                      ) : (
                        <div className={styles.nobanner}></div>
                      ))}
                  </div>
                )
              })}
            </div>
            {/* carousal slider end */}
            {/* tab navbar starts */}
            <div className={styles.widget_parent}>
              <div
                className={`${styles.widget_container} ${SerachWidget === 'hotel'
                  ? styles.hotel_widget
                  : SerachWidget === 'activity'
                    ? styles.activity_widget
                    : styles.activity_widget // default to activity
                  }`}
              >
                <div className="container mx-auto offiletab xl:px-8">
                  <div className={styles.search}>
                    <div className={styles.holidaymaintabnavbarrow}>
                      <div className={styles.holidaycarouselcontainer}>
                        <nav className={styles.navbartab}>
                          <ul>
                            {props?.home?.data?.data?.header?.menu
                              .filter((ele) => ele.status.toLowerCase() == 'active')
                              .slice(0, 7)
                              .map((res, i) => {
                                return (
                                  <>
                                    {res.code != 'others' ? (
                                      <Link
                                        title={res.text}
                                        key={res.text}
                                        href={res.url}
                                        className=""
                                      >
                                        <li
                                          className={
                                            SerachWidget === res.code ? styles.activetab : ''
                                          }
                                          onClick={() => {
                                            setSerachWidget(res.code)
                                          }}
                                        >
                                          <div className={styles.service_icon}>
                                            <img
                                              src={`${'/shared/api/media/' +
                                                props.site_id +
                                                '/' +
                                                res.icon
                                                }`}
                                              alt={res.code}
                                            />
                                          </div>
                                          <span className={styles.service_label}>{res.text}</span>
                                        </li>
                                      </Link>
                                    ) : (
                                      <a
                                        title={res.text}
                                        key={res.text}
                                        href={res.url}
                                        target="_blank"
                                        className=""
                                      >
                                        <li
                                          className={
                                            SerachWidget == 'others_search' ? styles.activetab : ''
                                          }
                                        >
                                          <div className={styles.service_icon}>
                                            {res.icon == '' ? (
                                              <img src="images/forexImg.svg" alt={res.code} />
                                            ) : (
                                              <img
                                                src={`${'/shared/api/media/' +
                                                  props.site_id +
                                                  '/' +
                                                  res.icon
                                                  }`}
                                                alt={res.code}
                                              />
                                            )}
                                          </div>
                                          {res.text}
                                        </li>
                                      </a>
                                    )}
                                  </>
                                )
                              })}

                            {props?.home?.data?.data?.header?.menu?.filter(
                              (ele) => ele.status.toLowerCase() == 'active'
                            ).length > 7 && (
                                <MoreMenu
                                  menuItems={props?.home?.data?.data?.header?.menu.slice(7)}
                                  styles={MoremenuCss}
                                  setMoreWrapperRef={setMoreWrapperRef}
                                  state={openMorePopup}
                                  setMorePopupHandler={setMorePopupHandler}
                                  site_id={props?.data?.data?.siteData?.site.id}
                                  showIcon={true}
                                />
                              )}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
                {/* tab navbar end */}
                {/* widgets components starts */}
                {/* -- */}

                <div>
                  {homeBodyDesktop.map((res, i) => {
                    return (
                      <div key={'homeBodyDsktp' + i}>
                        {/* {!cf.isValueEmpty(res.type) && res.type == 'image_banner' && (
                                    <div className="img_banner_home">
                                      <Image loader={imageLoader} src={res.banners} width={500} />
                                    </div>
                                  )} */}

                        {SerachWidget === 'hotel' && res.type == 'hotel_search' && (
                          <div className={styles.bb_widget_container_with_bg}>
                            <HotelSearchWidget
                              pageTheme={props?.home?.data?.site?.site_theme}
                              isSRP={false}
                              isOffline={false}
                              styles={DesktopHotelStylesTheme2}
                              b2bStyles={b2bWidgetStyle}
                              getAutoSuggestValue={(value) =>
                                getAutoSuggestDataFunc(value, 'hotel')
                              }
                              expandHotelNameBoolean={expandHotelNameBoolean}
                              getDefaultDays={hotelDefultDays}
                              getAutoSuggestList={getHotelAutoSuggestList}
                              getRecentSearchList={getrecentSearchList}
                              expandHotelNameBooleanfunc={(value) => setExpandHotelName(value)}
                              homeData={!cf.isValueEmpty(initHotelData) ? initHotelData : []}
                              dateFormat={props?.home?.data?.site?.date_format}
                              userProfile={userProfile}
                              Countrystyles={Countrystyles}
                              PopupMobCss={PopupMobCss}
                              PopularDestination={false}
                              paxCompStyle={paxCompStyle}
                              updateRecentSearch={updateRecentSearch}
                              state={state}
                              stays_villas={stays_villas}
                              onClickRecentSearch={onClickRecentSearch}
                              isMobile={props?.isMobile}
                              // recentSearchData={recentSearchData}
                              setStateNew={(data) => setState({ ...state, ...data })}
                            />
                          </div>
                        )}

                        {SerachWidget == 'activity' && res.type == 'activity_search' && (
                          <div className={styles.bb_widget_container_with_bg}>
                            <SearchWidgetActivity
                              {...props}
                              //  cssfile={cssfile}
                              cssfile={ActivityTheme2cssfile}
                              pageTheme={props?.home?.data?.site?.site_theme}
                              calendarStyles={ActivityTheme2cssfile}
                              dateFormat={props?.home?.data?.site?.date_format}
                              b2bStyles={b2bWidgetStyle}
                              isMobile={props?.isMobile}
                              popupcss={PopupMobCss}
                              isSrp={false}
                              homePage={"homePage"}
                            />
                          </div>
                        )}
                      </div>
                    )
                  })}

                </div>
              </div>
            </div>


            {SerachWidget == 'activity' && renderRecentAndBooking()}
            {homeBodyDesktop.map((res, i) => {

              return res?.type === 'promotion_banner' ? (
                <div className={styles.promomainbanner} key={'homeBodyDsktp' + i}>
                  <PromotionBanner
                    theme={props?.home?.data?.site?.site_theme}
                    isMobile={props?.isMobile}
                    responsive={responsive}
                    res={res}
                    imageLoader={imageLoader}
                    cssstyles={styles}
                    showIndicators={true && res?.banners?.length > 1}
                  />
                </div>
              ) : (
                <div key={'homeBodyDsktp' + i}>
                  <div>
                    {!cf.isValueEmpty(res.html)
                      ? parse(res.html, {
                        replace: ({ attribs }) => {
                          if (attribs && attribs.copycouponcode === 'copy') {
                            return (
                              <p
                                className="copyZth"
                                copycouponcode="copy"
                                copycouponcodevalue={attribs.copycouponcodevalue}
                                copycouponcodenumber={attribs.copycouponcodenumber}
                                id={attribs.id}
                                onClick={() => copyCouponCode(attribs.copycouponcodenumber)}
                              >
                                Copy Code
                              </p>
                            )
                          }
                        },
                      })
                      : ''}
                  </div>
                </div>
              )
            })}
          </div>

          {/* cards & other data  end */}
        </>
      )}

    </>
  )

}




